<div
  class="typo-h6-light flex h-8 w-8 items-center justify-center rounded-sm font-medium"
  [ngClass]="{
    'bg-text-extra-light': !disabled(),
    'bg-background-disabled': disabled(),
    'text-text-light': disabled(),
    'text-text-secondary': !disabled()
  }"
>
  <ng-content />
</div>
